import { ConfidentialResourceAccessRequest } from '@dreryk/egabinet-medical-data-confidentiality-frontend-api';

import { useBoolean } from '@dreryk/react-common';

import { ConfidentialResourcesModal } from './ConfidentialResourcesModal';

type ConfidentialResourcesModalOpenerRenderProps = {
   openModal: VoidFunction;
};

type ConfidentialResourcesModalOpenerProps = {
   children: (renderProps: ConfidentialResourcesModalOpenerRenderProps) => JSX.Element;
   request: ConfidentialResourceAccessRequest;
};

export const ConfidentialResourcesModalOpener = (props: ConfidentialResourcesModalOpenerProps): JSX.Element => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean(false);

   return (
      <>
         {props.children({ openModal: openModal })}
         {modalOpened ? <ConfidentialResourcesModal request={props.request} onClose={closeModal} /> : null}
      </>
   );
};
